import React from 'react'
import { Link } from 'react-router-dom'
import { MdDoubleArrow } from 'react-icons/md'
import { ABOUT_PAGE_URL, COMMERCIALS_PAGE_URL, CONTACT_PAGE_URL, WELLNESS_PAGE_URL } from '../../utils/Routes'

function MainCta() {
  const ctas = [
    {
      label: 'VIEW COMMERCIALS',
      to: COMMERCIALS_PAGE_URL,
      aria: 'View Commercials Portfolio',
      title: 'Commercials'
    },
    {
      label: 'WELLNESS COACHING',
      to: WELLNESS_PAGE_URL,
      aria: 'Explore Wellness Coaching',
      title: 'Wellness coaching'
    },
    {
      label: 'ABOUT SIV',
      to: ABOUT_PAGE_URL,
      aria: 'About',
      title: 'About Siv Renate'
    },
    {
      label: 'CONTACT & BOOKING',
      to: CONTACT_PAGE_URL,
      aria: 'Contact & Booking',
      title: 'Contact and booking'
    },
  ]

  return (
    <section className="grid bg-colour5 text-colour1">
      <div className="grid gap-8 px-8 py-8 xl:py-24 2xl:px-32 lg:px-16">
        <h3 className="text-center font-titleFont text-xl underline underline-offset-8">Explore More</h3>

        <div className="grid gap-4 lg:grid-cols-4">
          {ctas.map((cta, index) => (
            <Link
              key={index}
              to={cta.to}
              className="grid text-xl md:text-sm w-full p-1 bg-colour1 text-colour5 shadow-lg font-semibold font-poppins hover:brightness-90 duration-200 h-fit"
              aria-label={cta.aria}
              rel="bookmark"
              title={cta.title}
            >
              <div className="grid grid-cols-rev items-center border-[1px] border-colour5 border-solid gap-x-8 py-1 px-4 lg:py-2 lg:px-8">
                <span>{cta.label}</span>
                <MdDoubleArrow className="text-xl lg:text-2xl" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}

export default MainCta
